import { BarceloComponent } from "components-utils";

const ComparatorsComponents = {
  cardHotelCompactMeeting: BarceloComponent({
    selector: ".meetings-comparator",
    path: "barcelo/comparators/card-hotel-compact-meeting/js/card-hotel-compact-meeting",
  }),

  comparatorsInitializer: BarceloComponent({
    selector: ".c-hotels-comparator:not(.c-hotel-meeting-rooms .c-hotels-comparator):not([data-cardtype='card-offerwedding']):not([data-cardtype='card-wedding']):not([data-meet-page])",
    path: "barcelo/comparators/comparators-initializer/js/comparators-initializer",
    ignoreViewport: true,
  }),
};

export default ComparatorsComponents;
